module.exports = __webpack_public_path__ + "img/p.8603c76a.jpg";